import { zSchema } from "../../../schema-validation";

export const companyVerifyAchSchema = zSchema.object({
  deposits: zSchema.array(zSchema.string()),
  odo_user_id: zSchema.string(),
  payment_destination_id: zSchema.string().optional(),
});
